import React, { useState, useEffect } from 'react';
import './Pages.css';

function ContactUs() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [status, setStatus] = useState('');
  const [emailError, setEmailError] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);

  // Email validation regex pattern
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    setFormData({
      ...formData,
      [name]: value
    });

    // Validate email in real-time
    if (name === 'email') {
      if (value && !emailPattern.test(value)) {
        setEmailError('Please enter a valid email address');
      } else {
        setEmailError('');
      }
    }
  };

  // Check if form is valid
  const isFormValid = () => {
    return (
      formData.name.trim() !== '' &&
      formData.email.trim() !== '' &&
      emailPattern.test(formData.email) &&
      formData.subject.trim() !== '' &&
      formData.message.trim() !== ''
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!isFormValid()) {
      setStatus('Please fill out all fields correctly.');
      return;
    }
    
    setStatus('Sending...');
    
    // Check if running locally
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      console.log('LOCAL TEST - Form data:', formData);
      setShowSuccess(true);
      setFormData({ name: '', email: '', subject: '', message: '' });
      setStatus('');
      setTimeout(() => {
        setShowSuccess(false);
      }, 5000);
      return;
    }
    
    // Encode form data for Netlify
    const encode = (data) => {
      return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
    };

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact", ...formData })
    })
      .then(() => {
        setShowSuccess(true);
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
        setStatus('');
        
        // Hide success message after 5 seconds
        setTimeout(() => {
          setShowSuccess(false);
        }, 5000);
      })
      .catch(error => {
        setStatus('Error sending message. Please try again.');
        console.error('Form submission error:', error);
      });
  };

  useEffect (() => {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        console.log('Ad showing...');
      } catch (e) {
        console.error('Adsense error:', e);
      }
    }, []);

  return (
    <div className="page-container">
      <div className="contact-container">
        <h1>Contact Us</h1>
        <p className="contact-intro">
          Have questions or feedback? We'd love to hear from you!
        </p>

        {showSuccess && (
          <div className="success-message">
            <h3>✓ Message Sent!</h3>
            <p>Thank you for contacting us. We'll get back to you as soon as we can.</p>
          </div>
        )}

        <form 
          className="contact-form" 
          onSubmit={handleSubmit}
          name="contact"
          method="POST"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
        >
          {/* Hidden input for Netlify */}
          <input type="hidden" name="form-name" value="contact" />
          
          {/* Honeypot for spam protection */}
          <p style={{ display: 'none' }}>
            <label>
              Don't fill this out if you're human: <input name="bot-field" />
            </label>
          </p>

          <div className="form-group">
            <label htmlFor="name">Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Your name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="your.email@example.com"
              className={emailError ? 'error' : ''}
            />
            {emailError && <span className="error-message">{emailError}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="subject">Subject *</label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
              placeholder="What is this about?"
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Message *</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="6"
              placeholder="Your message here..."
            ></textarea>
          </div>

          <button 
            type="submit" 
            className="submit-btn"
            disabled={!isFormValid()}
          >
            Send Message
          </button>

          {status && <p className="status-message">{status}</p>}
        </form>
      </div>
    </div>
  );
}

export default ContactUs;
